import gql from "graphql-tag";

export const MUTATION_EDIT_REPORT = gql`
  mutation editReport(
    $reportId: String!
    $reportNumber: String!
    $name: String!
    $orderConfirmation: String!
    $shippingDate: DateTime!
    $customerOrderNumber: String!
    $products: [EditReportProductInput!]!
    $customer: String
    $supplier: String
    $productionPlant: String
    $work_order_nr: String
    $orderDate: DateTime
  ) {
    editReport(
      reportId: $reportId
      reportNumber: $reportNumber
      name: $name
      orderConfirmation: $orderConfirmation
      customerOrderNumber: $customerOrderNumber
      shippingDate: $shippingDate
      products: $products
      customer: $customer
      supplier: $supplier
      productionPlant: $productionPlant
      work_order_nr: $work_order_nr
      orderDate: $orderDate
    )
  }
`;
